import SelectedTick from "../../../../assets/images/selected-tick.svg";
import ExploreSearch from "../../../../assets/images/explore-search.svg";
import styled from "styled-components";
import { useContext, useState } from "react";
import LayoutContext from "../../../../contexts/LayoutContext";
const StyledBrand = styled.div`
    &.dropdown-mini,
    &.dropdown-mini * {
        box-sizing: border-box;
    }
    &.dropdown-mini {
        background: var(--surface-surface-tertiary, #212121);
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 215px;
        position: absolute;
        box-shadow: var(--dropdown-ds-box-shadow, 0px 0px 10px 0px rgba(17, 22, 32, 1));
        z-index: 9;
        margin-top: 5px;
        max-height: 332px;
        overflow: scroll;
    }
    .frame-1000011168 {
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .search {
        background: var(--surface-surface-tertiary, #212121);
        border-radius: 8px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 38px;
        position: relative;
    }
    .search-sm {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        position: relative;
        overflow: visible;
    }
    .text-label-here {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-size: var(--subtitle-1-font-size, 16px);
        line-height: var(--subtitle-1-line-height, 24px);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
        width: 147px;
        height: 24px;
        background: transparent;
        border: none;
        outline: none;
    }
    .frame-75 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        overflow: auto;
        max-height: 227px;
    }
    .frame-75::-webkit-scrollbar {
        width: 4px;
    }
    .frame-75::-webkit-scrollbar-track {
        background: transparent;
    }
    .frame-75::-webkit-scrollbar-thumb {
        background-color: #3e3e3e;
        border-radius: 50px;
    }
    .frame-79 {
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .frame-79:hover {
        background: #282828;
    }
    .checkbox {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-313638 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .all {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }

    .checkbox2 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .ellipse-1 {
        border-radius: 50%;
        border-style: solid;
        border-color: var(--border-border-secondary, #8c8f93);
        border-width: 1px;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .frame-313639 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .rectangle-5 {
        background: #3e3e3e;
        border-radius: 999px;
        flex-shrink: 0;
        width: 4px;
        height: 51px;
        position: absolute;
        right: 4px;
        top: 50%;
        translate: 0 -50%;
    }
    .frame-3136392 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .btn-xs-primary {
        background: var(--salmon, #f7665f);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
        cursor: pointer;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export default function Brand({ toggleBrandSelection, selectedBrands, getBrandDisplayText, setTriggerSearch }) {
    const { activeBrandList, setShowBrandFilter } = useContext(LayoutContext);
    const [searchText, setSearchText] = useState("");

    const isAllSelected =
        getBrandDisplayText() === "All" ||
        (Array.isArray(selectedBrands) && Array.isArray(activeBrandList) && selectedBrands.length === activeBrandList.length);

    //const filteredBrandList = activeBrandList?.filter(brand => brand?.brandName?.toLowerCase().includes(searchText?.toLowerCase()));
    const filteredBrandList = activeBrandList?.filter(brand => brand?.name?.toLowerCase().includes(searchText?.toLowerCase()));

    return (
        <StyledBrand className="dropdown-mini" style={{ minWidth: "270px" }}>
            <div className="frame-1000011168">
                <div className="search">
                    <img className="search-sm" src={ExploreSearch} alt="search-sm0.svg" />
                    <input
                        type="text"
                        className="text-label-here"
                        placeholder="Search"
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                    />
                </div>
            </div>
            <div className="frame-75">
                <div className="frame-79" onClick={() => toggleBrandSelection("all")}>
                    <div className="checkbox2">
                        <div className="ellipse-1">
                            {isAllSelected && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                        </div>
                    </div>
                    <div className="frame-313638">
                        <div className="all">All</div>
                    </div>
                </div>
                {Array.isArray(filteredBrandList) &&
                    filteredBrandList.map((value, index) => {
                        const brandId = value._id;
                        const isSelected = selectedBrands.includes(brandId);
                        return (
                            <div className="frame-79" key={brandId} onClick={() => toggleBrandSelection(brandId)}>
                                <div className="checkbox2">
                                    <div className="ellipse-1">
                                        {isSelected && <img className="checkbox" src={SelectedTick} alt="checkbox0.svg" />}
                                    </div>
                                </div>
                                <div className="frame-313638" style={{ width: "100%", overflow: "hidden" }}>
                                    <div className="all text-one-line">{value?.name}</div>
                                </div>
                            </div>
                        );
                    })}
            </div>
            <div className="frame-3136392">
                <div
                    className="btn-xs-primary"
                    onClick={e => {
                        e.stopPropagation();
                        setShowBrandFilter(false);
                        setTriggerSearch(true);
                    }}>
                    <div className="button">Done</div>
                </div>
            </div>
        </StyledBrand>
    );
}
